"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAdditionalRole_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var UserRoleType_1 = require("./UserRoleType");
var UserAdditionalRole_Factory = /** @class */ (function () {
    function UserAdditionalRole_Factory() {
    }
    UserAdditionalRole_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            RecordId: model.RecordId,
            User: User_1.User_Factory.CreateIncoming(model.User),
            UserId: model.UserId,
            UserRoleType: UserRoleType_1.UserRoleType_Factory.CreateIncoming(model.UserRoleType),
            UserRoleTypeCode: model.UserRoleTypeCode,
        };
        return result;
    };
    UserAdditionalRole_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            RecordId: model.RecordId,
            User: User_1.User_Factory.CreateOutgoing(model.User),
            UserId: model.UserId,
            UserRoleType: UserRoleType_1.UserRoleType_Factory.CreateOutgoing(model.UserRoleType),
            UserRoleTypeCode: model.UserRoleTypeCode,
        };
        return result;
    };
    return UserAdditionalRole_Factory;
}());
exports.UserAdditionalRole_Factory = UserAdditionalRole_Factory;
